@if (prodListConf$ | async; as conf) {
  <div class="layout-col full">
    <!-- Header Section -->
    <div class="layout-row">
      @if (embedded) {
        <div class="flex layout-row place-start-center gap-md p-lg">
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: conf }"
          ></ng-template>
        </div>
      } @else {
        <mat-toolbar elderTheme class="gap-md">
          <button mat-icon-button (click)="onClose($event)">
            <mat-icon>close</mat-icon>
          </button>
          <ng-template
            [ngTemplateOutlet]="header"
            [ngTemplateOutletContext]="{ $implicit: conf }"
          ></ng-template>
        </mat-toolbar>
      }
    </div>
    <!-- Content -->
    <div class="flex layout-col">
      <mat-tab-group class="flex" animationDuration="0ms" elderTabGroupRouting="wcTypeDetailTab">
        <!-- Tab Overview -->
        <mat-tab label="{{ 'context.overview' | translate }}">
          <elder-basic-pane-layout class="full">
            <elder-pane>
              <elder-pane-header>
                <elder-pane-title>{{ 'context.general' | translate }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                  <button mat-icon-button [matMenuTriggerFor]="menu" [disabled]="creationMode">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item (click)="onDelete($event)" [disabled]="!deletionEnabled">
                      <mat-icon>delete</mat-icon>
                      <span>{{ 'actions.delete' | translate }}</span>
                    </button>
                  </mat-menu>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content>
                <form #mainFrm="ngForm" class="flex layout-row gap-xl">
                  <div class="flex-20 layout-col">
                    <!-- Identifications -->
                    <elder-pane-subtitle>{{
                      'context.identification' | translate
                    }}</elder-pane-subtitle>
                    <div class="layout-col gap-md">
                      <!-- ID input -->
                      <mat-form-field class="flex">
                        <mat-label>{{ 'context.id' | translate }}</mat-label>
                        <input
                          matInput
                          name="id"
                          #idModel="ngModel"
                          required
                          [disabled]="!creationMode"
                          placeholder="{{ 'context.id' | translate }}"
                          pattern="{{ idValidatorPattern }}"
                          [(ngModel)]="conf.id"
                        />
                        <mat-error elderValidationError></mat-error>
                      </mat-form-field>
                      <!-- Scope -->
                      <mat-form-field>
                        <elder-select
                          appProdListScopeSelect
                          name="scope-select"
                          class="flex"
                          required
                          valueAsId
                          [(value)]="conf.scope"
                        >
                        </elder-select>
                      </mat-form-field>
                      <!-- Name -->
                      <elder-localized-input name="name" [(ngModel)]="conf.nameI18n">
                      </elder-localized-input>
                      <!-- Template input -->
                      <mat-form-field class="flex">
                        <mat-label>{{ 'context.template' | translate }}</mat-label>
                        <input
                          matInput
                          name="templateId"
                          #idModel="ngModel"
                          required
                          placeholder="{{ 'context.template' | translate }}"
                          pattern="{{ idValidatorPattern }}"
                          [(ngModel)]="conf.templateId"
                        />
                        <mat-error elderValidationError></mat-error>
                      </mat-form-field>
                      <div class="layout-row">
                        <!-- Material list enabled -->
                        <mat-checkbox
                          [(ngModel)]="conf.resolveMaterialList"
                          name="resolveMaterialList"
                        >
                          {{ 'materials.list' | translate }}
                        </mat-checkbox>
                        <!-- Aggregate Material list -->
                        <mat-checkbox
                          [(ngModel)]="conf.aggregateMaterials"
                          [disabled]="!conf.resolveMaterialList"
                          name="aggregateMaterials"
                        >
                          {{ 'materials.aggregate' | translate }}
                        </mat-checkbox>
                      </div>
                    </div>
                  </div>
                </form>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
        <!-- Tab distinct properties -->
        <mat-tab label="{{ 'positions.distinct-properties' | translate }}">
          <elder-basic-pane-layout class="full">
            <elder-pane>
              <elder-pane-header>
                <elder-pane-title>{{
                  'positions.distinct-properties' | translate
                }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content class="flex p-0" padding="0">
                <div class="flex layout-col gap-md">
                  <app-item-property-definition-organizer
                    class="flex"
                    [(properties)]="prodListConf.distinctProperties"
                  >
                  </app-item-property-definition-organizer>
                </div>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
        <!-- Tab Columns definitions -->
        <mat-tab label="{{ 'positions.columns-conf.definitions' | translate }}">
          <elder-basic-pane-layout class="full">
            <elder-pane>
              <elder-pane-header>
                <elder-pane-title>{{
                  'positions.columns-conf.definitions' | translate
                }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content class="flex p-0" padding="0">
                <div class="flex layout-col gap-md">
                  <app-columns-conf-detail
                    class="flex"
                    [columnsConf]="conf.columnsConf"
                    [embedded]="true"
                  >
                  </app-columns-conf-detail>
                </div>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
        <!-- Tab Item sort -->
        <mat-tab label="{{ 'context.itemsSort' | translate }}">
          <elder-basic-pane-layout class="full">
            <elder-pane>
              <elder-pane-header>
                <elder-pane-title>{{ 'context.itemsSort' | translate }}</elder-pane-title>
                <elder-pane-actions>
                  <button mat-icon-button (click)="onSave($event)">
                    <mat-icon>save</mat-icon>
                  </button>
                </elder-pane-actions>
              </elder-pane-header>
              <elder-pane-content class="flex p-0" padding="0">
                <div class="flex layout-col gap-md">
                  <app-item-sort-spec-detail class="flex" [(itemSortSpec)]="conf.itemSortSpec">
                  </app-item-sort-spec-detail>
                </div>
              </elder-pane-content>
            </elder-pane>
          </elder-basic-pane-layout>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
}

<ng-template #header let-property>
  @if (creationMode) {
    <span>
      {{ 'properties.new' | translate }}
    </span>
  } @else {
    <elder-header
      [header]="'orders.prod.list.title' | translate"
      [subheader]="'ID: ' + property?.id"
    >
    </elder-header>
  }
</ng-template>
